import { useEffect, useMemo, useState } from "react";
import useB2BTranslation from "../../../../b2b-common/hooks/useB2BTranslation";
import useGettingWidgetData from "../../../hooks/useGettingWidgetData";
import ORGANIZATION_AREA_INDICATORS_WidgetLayout from "./ORGANIZATION_AREA_INDICATORS_WidgetLayout";
import { Box, Typography } from "@mui/material";

const ORGANIZATION_AREA_INDICATORS_Widget = ({ widget, atPublicDashboard = false, password = null }) => {
    const { t } = useB2BTranslation('b2b-reporting');
    const { widgetData, loading } = useGettingWidgetData(widget, atPublicDashboard, password);
    const [areaIndicatorsData, setAreaIndicatorsData] = useState(null);
    const [percentage, setPercentage] = useState(null);
    const [totalCount, setTotalCount] = useState(null);

    useEffect(() => {
        if (!widgetData) return;
        setAreaIndicatorsData(widgetData?.widgetResponse?.areaIndicatorsData || null);
        setPercentage(widgetData?.widgetResponse?.percentage || null);
        setTotalCount(widgetData?.widgetResponse?.totalCount || null);
    }, [widgetData]);

    const status = widget?.widgetConfig?.extraFields?.status || "green";
    const frameworkId = widget?.widgetConfig?.extraFields?.frameworkId || 2;
    const onlyFrameworkIndicators = widget?.widgetConfig?.extraFields?.onlyFrameworkIndicators || false;

    const filteredAreaIndicatorsData = useMemo(() => {
        if (!onlyFrameworkIndicators || !areaIndicatorsData) return areaIndicatorsData;
        return areaIndicatorsData.filter(item =>
            item.indicatorDTO?.frameworksLevel1sDTOs?.some(framework =>
                framework.frameworkDTO?.frameworkId === frameworkId &&
                Array.isArray(framework.level1sDTOs) &&
                framework.level1sDTOs.length > 0
            )
        );
    }, [onlyFrameworkIndicators, areaIndicatorsData, frameworkId]);

    if (loading || !filteredAreaIndicatorsData) {
        return (
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={120}>
                <Typography>{t('Loading...')}</Typography>
            </Box>
        );
    }

    return (
        <ORGANIZATION_AREA_INDICATORS_WidgetLayout
            status={status}
            areaIndicatorsData={filteredAreaIndicatorsData}
            percentage={!onlyFrameworkIndicators ? percentage : (filteredAreaIndicatorsData.length / totalCount) * 100}
            totalCount={totalCount}
            loggedIn={!atPublicDashboard}
            isSearching={loading}
            atPublicDashboard={atPublicDashboard}
            frameworkId={frameworkId}
            onlyFrameworkIndicators={onlyFrameworkIndicators}
        />
    );
};

export default ORGANIZATION_AREA_INDICATORS_Widget;
